exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://use.typekit.net/srv0wme.css);", ""]);

// module
exports.push([module.id, "/*\r\n$breakpoint argument choices:\r\n- xs\r\n- sm\r\n- md\r\n- lg\r\n- xl\r\n*/\n.searchExpanded[data-v-a92aebf4] {\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.searchExpanded .icon[data-v-a92aebf4] {\n    position: absolute;\n    top: 25px;\n    left: 12px;\n}\n", ""]);

// exports
